<script lang="ts">
  import type { Conversation } from '@/stores/messages';

  interface Props {
    conversation: Conversation;
    onAccept: () => void;
    onDecline: () => void;
    onBlock: () => void;
    onReport: () => void;
  }

  let { conversation, onAccept, onDecline, onBlock, onReport }: Props = $props();
  let busy = $state(false);

  async function handle(action: () => Promise<void> | void) {
    if (busy) return;
    busy = true;
    try {
      await action();
    } finally {
      busy = false;
    }
  }
</script>

<div class="border-b border-default bg-yellow-50 dark:bg-yellow-500/10 px-4 py-3">
  <div class="flex items-start gap-3">
    <div class="shrink-0 w-9 h-9 rounded-full bg-yellow-100 dark:bg-yellow-500/20 text-yellow-700 dark:text-yellow-300 flex items-center justify-center">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-body2 font-medium text-content">
        <strong>{conversation.other_participant.name}</strong>님이 보낸 새 메시지 요청입니다.
      </p>
      <p class="text-body2 text-content-tertiary mt-0.5">
        수락하면 일반 대화로 전환됩니다. 답장만으로도 자동 수락돼요.
      </p>

      <div class="mt-3 flex flex-wrap gap-2">
        <button type="button" class="btn btn-primary btn-sm" disabled={busy} onclick={() => handle(onAccept)}>
          수락
        </button>
        <button type="button" class="btn btn-ghost btn-sm" disabled={busy} onclick={() => handle(onDecline)}>
          거절
        </button>
        <button type="button" class="btn btn-ghost btn-sm text-error" disabled={busy} onclick={() => handle(onBlock)}>
          차단
        </button>
        <button type="button" class="btn btn-ghost btn-sm" disabled={busy} onclick={() => handle(onReport)}>
          신고
        </button>
      </div>
    </div>
  </div>
</div>
